<template>
  <div>
    <div class="w-100 h-100">
      <Nav :rolname="rolname" :type="type" />
    </div>
    <!-- CONTENIDO PARA MEDICO DE CLINICA E INTERCONSULTISTA -->
    <div class="content">
      <Home
        v-if="page == 'home' || page == 'homeAtencion'"
        :type="type"
        @mtdChangePage="mtdChangePage"
      />
      <ControlDiario v-if="page == 'control'" @mtdChangePage="mtdChangePage" />
      <Consulta
        v-if="page == 'consulta'"
        @mtdChangePage="mtdChangePage"
        @mtdpaciente="mtdpaciente"
        :patientold="patientold"
        @mtdpacienteold="mtdpacienteold"
        @mtdFinish="mtdFinishCon"
        :rolname="rolname"
      />
      <Interconsulta
        v-if="page == 'interconsulta'"
        :patient="patient"
        :rolname="rolname"
      />
      <Hospitalizacion
        v-if="page == 'hospitalizacion'"
        @mtdChangePage="mtdChangePage"
        @mtdpaciente="mtdpaciente"
        :patientold="patientold"
        @mtdpacienteold="mtdpacienteold"
        @mtdFinish="mtdFinish"
        :rolname="rolname"
        :type="type"
      />
      <Uciadulto
        v-if="page == 'uciadulto'"
        @mtdChangePage="mtdChangePage"
        @mtdpaciente="mtdpaciente"
        :patientold="patientold"
        @mtdpacienteold="mtdpacienteold"
        @mtdFinish="mtdFinishUci"
        :rolname="rolname"
        :type="type"
      />
      <Ucineo v-if="page == 'ucineo'" />
      <Sop
        v-if="page == 'sop'"
        @mtdChangePage="mtdChangePage"
        @mtdpaciente="mtdpaciente"
        @mtdpacienteold="mtdpacienteold"
        :patientold="patientold"
        :rolname="rolname"
        :type="type"
        @mtdFinish="mtdFinishSop"
      />
      <Emergencia
        v-if="page == 'emergencia'"
        @mtdChangePage="mtdChangePage"
        @mtdpaciente="mtdpaciente"
        :patientold="patientold"
        @mtdpacienteold="mtdpacienteold"
        @mtdFinish="mtdFinishEmergency"
        :rolname="rolname"
        :type="type"
      />
      <Laboratorio
        v-if="page == 'laboratorio'"
        :patient="patient"
        :type="type"
        @mtdChangePage="mtdChangePage"
      />
      <Imagen
        v-if="page == 'imagen'"
        :patient="patient"
        :type="type"
        @mtdChangePage="mtdChangePage"
      />
      <Procedimiento
        v-if="page == 'procedimiento'"
        :patient="patient"
        :type="type"
        @mtdChangePage="mtdChangePage"
      />
      <Devoluciones
        v-if="page == 'devoluciones'"
        :patient="patient"
        :id_medical="id_medical"
      />
      <Historia v-if="page == 'historia'" :num="num" />
      <RequerimientosInsumos
        v-if="page == 'requerimientos'"
        @mtdChangePage="mtdChangePage"
      />
      <HomeCirujano
        v-if="page == 'homeCirujano'"
        @mtdChangePage="mtdChangePage"
      />
      <OrdenSop
        v-if="page == 'orden'"
        @mtdChangePage="mtdChangePage"
      ></OrdenSop>
    </div>
    <!-- cirujano -->
    <div class="content" v-if="type == 4">
      <HomeCirujano v-if="page == 'home'" @mtdChangePage="mtdChangePage" />
      <Home v-if="page == 'homeAtencion'" @mtdChangePage="mtdChangePage" />
    </div>
    <div class="footer" v-if="showFooter">
      <Footer
        @mtdChangePage="mtdChangePage"
        :pageView="page"
        :patient="patient"
        :pagefinish="pagefinish"
        @mtdback="mtdback"
        :rolname="rolname"
        :type="type"
      />
    </div>
    <!-- Off canvas de cola de paciente -->
    <div
      v-if="showFooter"
      class="load-patient"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasRight"
      aria-controls="offcanvasRight"
    >
      <i class="far fa-user-circle"></i>
    </div>
    <div
      class="offcanvas offcanvas-end"
      data-bs-backdrop="true"
      data-bs-scroll="true"
      tabindex="-1"
      id="offcanvasRight"
      aria-labelledby="offcanvasRightLabel"
    >
      <div class="offcanvas-header border">
        <h5 class="offcanvas-title" id="offcanvasRightLabel">
          Cola de Pacientes
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div class="offcanvas-body align-center">
        <div class="home__wait">
          <div class="home__wait-div">
            <div class="home__wait-user">
              <i class="far fa-user-circle"></i>
              <ul class="list-patient">
                <li>
                  <b>Paciente</b>
                </li>
                <li v-if="Object.keys(patient).length != 0">
                  {{ patient.patient_name }}
                </li>
                <li v-else-if="Object.keys(patientnew).length != 0">
                  {{ patientnew.patient_name }}
                </li>
                <li v-else>No ha seleccionado un paciente aun</li>
                <li>
                  <b>Provincia</b>
                </li>
                <li v-if="Object.keys(patient).length != 0">
                  {{ patient.place }}
                </li>
                <li v-if="Object.keys(patientnew).length != 0">
                  {{ patientnew.place }}
                </li>
                <li>
                  <b>Ultima cita</b>
                </li>
                <li v-if="Object.keys(patient).length != 0">
                  {{ patient.lastAtention }} - {{ patient.ServiceLastAtention }}
                </li>
                <li v-if="Object.keys(patientnew).length != 0">
                  {{ patientnew.lastAtention }} -
                  {{ patientnew.ServiceLastAtention }}
                </li>
              </ul>
            </div>
            <div
              class="home__wait-buttons"
              v-if="Object.keys(patient).length > 0"
            >
              <button
                @click="openModalRecipe(patient)"
                class="btn btn-outline-atendiendo w-100 mb-2"
                v-if="page != 'consulta'"
              >
                <strong>Receta de Alta</strong>
              </button>
              <button
                @click="openDestino"
                v-if="type == 1 || type == 3 || type == 2"
                class="btn btn-outline-atendiendo w-100 mb-2"
              >
                <strong>Destino</strong></button
              ><br />
              <button
                @click="mtdFinishTotal"
                class="btn btn-outline-atendiendo w-100"
              >
                <strong>Finalizar cita</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modalEpicrisis
      :title="modalEpicrisis.title"
      :boo_modal="modalEpicrisis.modal_form"
      @mtdclosemodalBed="mtdclosemodalBed"
      :datapatients="patient"
      @mtdRegisterAlta="mtdRegisterAlta"
    ></modalEpicrisis>
    <SweetAlert
      :swal="swal"
      ref="SweetAlert"
      @saveOperationRoom="saveOperationRoom"
    />
    <cModaldestino
      :rolname="rolname"
      :type_history="type_history"
      :subsubcategorie_id="subsubcategorie_id"
      :title="modal.title"
      :boo_modal="modal.modal_form"
      @mtdclosemodal="mtdclosemodal"
      :medicalAct="patient.medical_act_id"
      @mtdstoredata="mtdstoredata"
    />
    <cModalBed
      :bed="bed"
      :title="cModalBed.title"
      :boo_modal="cModalBed.modal_form"
      @mtdclosemodalBed="mtdclosemodalBed"
      @mtdstoredata="mtdstoredata"
      @mtdaddbed="mtdaddbed"
    />
    <cModalLecturaResultado
      :stateHour="stateHour"
      :title="cModalLectura.title"
      :boo_modal="cModalLectura.modal_form"
      @mtdclosemodalLectura="mtdclosemodalLectura"
      @mtdhorarioLectura="mtdhorarioLectura"
    />
    <cModalDestinoSop
      :rolname="rolname"
      :process="modalDestinoSop.process"
      :title="modalDestinoSop.title"
      :boo_modal="modalDestinoSop.modal_form"
      @mtdclosemodal="mtdclosemodal"
      :origin="'offcanva'"
      @mtdstoredata="mtdstoredata"
    ></cModalDestinoSop>
    <cModalRoom
      :title="cModalRoom.title"
      :boo_modal="cModalRoom.modal_form"
      @mtdclosemodalBed="mtdclosemodalBed"
      @saveOperationRoom="saveOperationRoom"
    ></cModalRoom>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Nav from "../../components/Asistencial/Nav.vue";
import Home from "../../components/Asistencial/Home.vue";
import Consulta from "../../components/Asistencial/ConsultaView.vue";
import Interconsulta from "../../components/Asistencial/InterconsultaView.vue";
import Hospitalizacion from "../../components/Asistencial/HospitalizacionView.vue";
import Uciadulto from "../../components/Asistencial/UciadultoView.vue";
import Ucineo from "../../components/Asistencial/UcineoView.vue";
import Sop from "../../components/Asistencial/SopView.vue";
import Emergencia from "../../components/Asistencial/EmergenciaView.vue";
import Footer from "../../components/Asistencial/Footer.vue";
import Laboratorio from "../../components/Asistencial/LaboratorioView.vue";
import Imagen from "../../components/Asistencial/ImagenesView.vue";
import Procedimiento from "../../components/Asistencial/ProcedimientoView.vue";
import cModaldestino from "@/components/Asistencial/Emergency/modals/cModaldestino.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import cModalBed from "@/components/Asistencial/Emergency/modals/cModalBed.vue";
import Devoluciones from "@/components/Asistencial/Devoluciones.vue";
import ControlDiario from "@/components/Asistencial/Control.vue";
import Historia from "@/components/Admision/pages/MedicalAct.vue";
import cModalLecturaResultado from "@/components/Asistencial/Consulta/modals/cModalLecturaHour.vue";
import RequerimientosInsumos from "@/components/Asistencial/Requirements/Requirements.vue";
import HomeCirujano from "../../components/Asistencial/HomeCirujano.vue";
import OrdenSop from "../../components/Asistencial/HomeCirujano/OrderSop.vue";
import cModalDestinoSop from "@/components/Asistencial/Sop/modals/cModaldestino.vue";
import moment from "moment";
import modalEpicrisis from "@/components/Asistencial/Sop/modals/cModalEpicrisis.vue";
import cModalRoom from "@/components/Asistencial/Hospitalizacion/modals/cModalRoom.vue";

export default {
  name: "AsistencialView",
  components: {
    Nav,
    Home,
    ControlDiario,
    Consulta,
    Interconsulta,
    Hospitalizacion,
    Uciadulto,
    Ucineo,
    Sop,
    Emergencia,
    Footer,
    Laboratorio,
    Imagen,
    Procedimiento,
    cModaldestino,
    SweetAlert,
    cModalBed,
    Devoluciones,
    Historia,
    cModalLecturaResultado,
    RequerimientosInsumos,
    HomeCirujano,
    OrdenSop,
    cModalDestinoSop,
    modalEpicrisis,
    cModalRoom,
  },
  data() {
    return {
      prefix: "asistencial",
      type: 1, // 1-> Titular 2->externo 3->cirujano
      page: "home",
      rol_name: null,
      stateRolAdmin: false,
      showFooter: true,
      patient: {},
      patientold: {},
      patientnew: {},
      modal: {
        title: "",
        modal_form: false,
      },
      modalDestinoSop: {
        title: "",
        modal_form: false,
        process: 0,
      },
      cModalRoom: {
        title: "",
        modal_form: false,
      },
      swal: null,
      cModalBed: {
        title: "",
        modal_form: false,
      },
      bed: {
        campu_id: null,
        type: null,
      },
      type_history: null,
      pagefinish: "",
      id_medical: 0,
      count: 0,
      num: 0,
      cModalLectura: {
        title: "",
        modal_form: false,
      },
      stateHour: false,
      subsubcategorie_id: null,
      sopProcess: 0,
      modalEpicrisis: {
        title: "",
        modal_form: false,
      },
    };
  },
  props: {
    rolname: String,
    dataRoles: Array,
  },
  created() {
    this.rol_name = this.rolname;
    this.mtdGetRolAdmin();
  },
  watch: {
    rolname: {
      handler: function (newValue) {
        if (newValue == "DOCTOR(A)") {
          this.verifyTypeDoctor();
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    verifyTypeDoctor: function () {
      let search = this.$store.getters.get__user.dni;
      this.get({
        url: this.$store.getters.get__url + "/Doctor/search/" + search,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          let doctor = response.data[0] ?? null;
          if (doctor) {
            this.type = Number(doctor.type);
            this.showFooter = this.type != 4 ? true : false;
            this.page = this.type != 4 ? "home" : "homeCirujano";
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdChangePage: function (page) {
      this.page = page;
      if (page == "devoluciones") {
        this.id_medical = this.patient.medical_act_id;
      }
      if (page == "homeAtencion") {
        this.showFooter = true;
      }
      if (page == "homeCirujano" && this.type == 3) {
        this.showFooter = false;
      }
    },
    mtdGetRolAdmin: function () {
      this.dataRoles.forEach((element) => {
        if (element.role_id == 1) {
          this.stateRolAdmin = true;
        }
      });
    },
    mtdpaciente: function (payload) {
      this.patient = payload.patient;
      this.patient.medical_act_id = Number(payload.patient.medical_act_id); // no borrar
      this.patientold = payload;
      this.sopProcess = this.$miVariableGlobalSopProcess;
    },
    mtdpacienteold: function (payload) {
      this.patientnew = payload.patient;
      this.sopProcess = this.$miVariableGlobalSopProcess;
    },

    mtdFinishTotal: function () {
      if (this.patient.type == 7) {
        this.page = "emergencia";
      } else if (this.patient.type == 3) {
        this.page = "hospitalizacion";
      } else if (this.patient.type == 1) {
        this.page = "consulta";
      } else if (this.patient.type == 4) {
        this.page = "uciadulto";
      }
      this.patient = {};
      this.patientold = {};
      this.patientnew = {};
      this.finishAndClose();
      this.pagefinish = this.page;
      // this.pagefinish=''
    },
    mtdFinish: function () {
      this.patient = {};
      this.patientold = {};
      this.patientnew = {};
      this.page = "hospitalizacion";
      this.finishAndClose();
    },
    mtdFinishUci: function () {
      this.patient = {};
      this.patientold = {};
      this.patientnew = {};
      this.page = "uciadulto";
      this.finishAndClose();
    },
    mtdFinishEmergency: function () {
      this.patient = {};
      this.patientold = {};
      this.patientnew = {};
      this.page = "emergencia";
      this.finishAndClose();
    },
    mtdFinishCon: function () {
      this.patient = {};
      this.patientold = {};
      this.patientnew = {};
      this.page = "consulta";
      this.finishAndClose();
    },
    mtdFinishSop: function () {
      this.patient = {};
      this.patientold = {};
      this.patientnew = {};
      this.page = "sop";
      this.finishAndClose();
    },
    // vaciarpatient: function () {
    //     this.patient = {}
    //     this.patientold = {}
    //     this.patientnew = {}
    // },
    openDestino: function () {
      const { status_medical, type, subsub_categorie_id } = this.patient;
      const { miVariableGlobalSopProcess } = this.$globalState;
      const esDoctor = this.rolname == "DOCTOR(A)";
      const esEnfermera = this.rolname == "ENFERMERA(O)";

      // Si el paciente ya fue dado de alta y el usuario es doctor
      if (status_medical == 1 && esDoctor) {
        this.$refs.SweetAlert.showSuccess(
          "El Paciente ya ha sido dado de alta"
        );
        this.mtdclosemodal();
        this.finishAndClose();
        return;
      }

      // Si está en la página SOP (sala de operaciones)
      if (this.page == "sop") {
        if (miVariableGlobalSopProcess != 3) {
          if (esDoctor) {
            this.$refs.SweetAlert.showInfo(
              "No está en el proceso Post Operatorio, para pasar a otro servicio"
            );
            return;
          }
          if (status_medical == 1 && esEnfermera) {
            this.modalDestinoSop = {
              title: "DESTINO",
              modal_form: true,
              process: 3,
            };
            return;
          }
          this.$refs.SweetAlert.showInfo("El doctor aún no da de alta");
          return;
        }
        // Si está en el proceso post operatorio
        this.modalDestinoSop = {
          title: "DESTINO ENTRE SOP",
          modal_form: true,
          process: miVariableGlobalSopProcess,
        };
      } else {
        this.modal = {
          title: "DESTINO",
          modal_form: true,
        };
      }

      this.type_history = type;
      this.subsubcategorie_id = subsub_categorie_id;
    },

    mtdclosemodal: function () {
      this.modal = {
        title: "",
        modal_form: false,
      };
      this.modalDestinoSop.modal_form = false;
    },
    mtdstoredata: function (payload, destination) {
      let medical_id = this.patient.medical_act_id;
      this.count = 0;
      if (payload == 0) {
        if (this.patient.type == 1) {
          //consulta
          if (
            this.patient.status_medical != 1 &&
            this.rolname == "ENFERMERA(O)"
          ) {
            this.$refs.SweetAlert.showInfo(
              "Solo el doctor puede dar de alta al paciente"
            );
            this.mtdclosemodal();
          } else {
            //cualquier otro servicio
            this.mtdAltaDoctorConsulta(medical_id, destination);
          }
        } else {
          if (
            this.patient.status_medical != 1 &&
            this.rolname == "ENFERMERA(O)"
          ) {
            this.$refs.SweetAlert.showInfo(
              "El doctor no ha dado de alta al paciente"
            );
            this.mtdclosemodal();
            this.finishAndClose();
          } else if (
            this.patient.status_medical == 1 &&
            this.rolname == "ENFERMERA(O)"
          ) {
            this.post({
              url: this.$store.getters.get__url + "/Emergency/countMedicine",
              token: this.$store.getters.get__token,
              params: {
                id: medical_id,
              },
            })
              .then((response) => {
                this.count = response.data;
                if (this.count == 0) {
                  this.post({
                    url:
                      this.$store.getters.get__url +
                      "/admision/destinationNurse",
                    token: this.$store.getters.get__token,
                    params: {
                      id: medical_id,
                    },
                  })
                    .then((response) => {
                      this.mtdclosemodal();
                      this.$refs.SweetAlert.showSuccess(response.message);
                      this.mtdFinishTotal();
                    })
                    .catch((errors) => {
                      console.log(errors);
                    });
                } else {
                  this.$refs.SweetAlert.showInfo(
                    "Devolver Todos los Medicamentos"
                  );
                  this.mtdclosemodal();
                  this.finishAndClose();
                }
              })
              .catch((errors) => {
                console.log(errors);
              });
          } else {
            if (this.type_history != 6) {
              this.mtdAltaOtrosServicios(medical_id, destination);
            } else {
              this.modalDestinoSop.modal_form = false;
              this.modalEpicrisis = {
                title: "EPICRISIS",
                modal_form: true,
              };
            }
          }
        }
      } else if (payload == 1) {
        this.cModalBed = {
          title: "Lista de Camas / Servicios",
          modal_form: true,
        };
        this.bed = {
          campu_id: this.$store.getters.get__campus,
          type: 3,
        };
        this.mtdclosemodal();
      } else if (payload == 2) {
        this.cModalBed = {
          title: "Lista de Camas / Servicios",
          modal_form: true,
        };
        this.bed = {
          campu_id: this.$store.getters.get__campus,
          type: 4,
        };
        this.mtdclosemodal();
      } else if (payload == 3) {
        this.cModalBed = {
          title: "Lista de Camas / Servicios",
          modal_form: true,
        };
        this.bed = {
          campu_id: this.$store.getters.get__campus,
          type: 7,
        };
        this.mtdclosemodal();
      } else if (payload == 4) {
        this.stateHour = true;
        this.cModalLectura = {
          title: "Seleccione Fecha y Hora",
          modal_form: true,
        };
        this.mtdclosemodal();
      } else if (payload == 6) {
        //buscar si hay ordenes de sop activas a su nombre
        this.get({
          url:
            this.$store.getters.get__url + "/Sop/searchSopOrder/" + medical_id,
          token: this.$store.getters.get__token,
        })
          .then((response) => {
            if (response.data) {
              let sop = response.data;
              //formatear la fecha
              let date = this.formatDate(sop.date);
              let hora = this.formatTime(sop.entry_time);
              let roomname = sop.operationroom.name;
              let doctor_name = sop.doctor.name + " " + sop.doctor.last_name;
              let html = `El paciente tiene una <b>Operacion programada</b> 
                            para <b> el dia  ${date} a hora ${hora} </b> en la  <b>${roomname} </b> con el Dr(a) ${doctor_name}`;
              this.$refs.SweetAlert.showInfoOrder(html, sop);
            } else {
              //seleccionar manualmente la sala de operaciones
              this.cModalRoom = {
                title: "Lista de Sala de Operaciones",
                modal_form: true,
              };
            }
            this.mtdclosemodal();
          })
          .catch((errors) => {
            console.log(errors);
          });
      }
    },
    mtdAltaDoctorConsulta: function (medical_id, destination) {
      this.post({
        url: this.$store.getters.get__url + "/admision/destinationDoctor",
        token: this.$store.getters.get__token,
        params: {
          id: medical_id,
          destination: destination,
        },
      })
        .then((response) => {
          // this.mtdclosemodal()
          this.$refs.SweetAlert.showSuccess(response.message);
          this.mtdclosemodal();
          // this.$refs.SweetAlert.showSuccess(response.message);
          this.mtdFinishTotal();
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdAltaOtrosServicios: function (medical_id, destination) {
      //alta oara servicios emergencia, uci y hospitalizacion
      this.post({
        url: this.$store.getters.get__url + "/admision/destination",
        token: this.$store.getters.get__token,
        params: {
          id: medical_id,
          destination: destination,
        },
      })
        .then((response) => {
          this.mtdclosemodal();
          this.$refs.SweetAlert.showSuccess(response.message);
          this.mtdFinishTotal();
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdRegisterAlta: function () {
      //Alta para sop
      this.modalEpicrisis.modal_form = false;
      let medical_id = this.patient.medical_act_id;
      this.post({
        url: this.$store.getters.get__url + "/admision/destination",
        token: this.$store.getters.get__token,
        params: {
          id: medical_id,
          destination: "ALTA",
        },
      })
        .then((response) => {
          this.mtdclosemodal();
          this.$refs.SweetAlert.showSuccess(response.message);
          this.mtdFinishTotal();
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    //guardar el order de sop
    saveOperationRoom(payload) {
      let data = {
        type: 6,
        patient_id: this.patient.patient_id,
        id: this.patient.medical_act_id,
        campu_id: this.$store.getters.get__campus,
        subsubcategorie_id: payload.subsubcategory_id,
        sop: payload,
      };
      this.post({
        url: this.$store.getters.get__url + "/admision/reservation",
        token: this.$store.getters.get__token,
        params: data,
      })
        .then((response) => {
          console.log("Asistencial de saveOperationRoom");
          this.mtdclosemodalBed();
          this.$refs.SweetAlert.showSuccess(response.message);
          this.mtdFinishTotal();
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    formatTime(time) {
      let arTime = time.split(":");
      if (arTime[0] <= 12) {
        return time + " am";
      } else {
        return arTime[0] - 12 + ":" + arTime[1] + " pm";
      }
    },
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    mtdclosemodalBed: function () {
      this.cModalBed = {
        title: "",
        modal_form: false,
      };
      this.modalEpicrisis = {
        title: "",
        modal_form: false,
      };
      this.cModalRoom = {
        title: "",
        modal_form: false,
      };
    },
    finishAndClose() {
      let offcanvasElement = document.getElementById("offcanvasRight");
      let offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvasElement);
      if (offcanvasInstance) {
        offcanvasInstance.hide();
      }
    },
    mtdaddbed: function (payload, type, subsubcategories) {
      let data = {
        type: type,
        bed_id: payload.id,
        patient_id: this.patient.patient_id,
        id: this.patient.medical_act_id,
        campu_id: this.$store.getters.get__campus,
        subsubcategorie_id: subsubcategories.id,
      };
      this.post({
        url: this.$store.getters.get__url + "/Asistencial/traslado",
        token: this.$store.getters.get__token,
        params: data,
      })
        .then((response) => {
          console.log("soy de asistencial ");
          this.mtdclosemodalBed();
          this.$refs.SweetAlert.showSuccess(response.message);
          this.mtdFinishTotal();
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    mtdback: function () {
      this.pagefinish = "";
    },
    mtdclosemodalLectura: function () {
      this.cModalLectura = {
        title: "",
        modal_form: false,
      };
      this.stateHour = false;
    },
    mtdhorarioLectura: function (date, hour) {
      let data = {
        id: this.patient.medical_act_id,
        date: date,
        hour: hour,
      };
      this.post({
        url: this.$store.getters.get__url + "/admision/lecturaResultado",
        token: this.$store.getters.get__token,
        params: data,
      })
        .then((response) => {
          this.$refs.SweetAlert.showSuccess(response.message);
          this.mtdclosemodal();
          this.mtdFinishTotal();
        })
        .catch((errors) => {
          console.log(errors);
        });
    },

    //Modal Receta Alta
    openModalRecipe: function (patient) {
      const closeButton = document.querySelector(".btn-close");
      if (closeButton) {
        closeButton.click();
      }
      /* this.$store.commit("mt_set_patient_data", {
                medical_act_id: patient.medical_act_id,
                clinical_historie_id: patient.id,
                patient_id: patient.patient_id
            }); */
      const dataPatient = {
        type: patient.type,
        medical_act_id: patient.medical_act_id,
        id: patient.id,
        patient_id: patient.patient_id,
        recomendations: "",
        dieta: "",
        recipe: JSON.stringify([]),
        //recipe: patient.recipe,
      };
      this.$emit("openModalRecipe", dataPatient, this.rolname);
    },
  },
};
</script>

<style>
.load-patient {
  position: absolute;
  right: 0;
  top: 42%;
  background: #900052;
  padding: 0.5rem;
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
  cursor: pointer;
}

.load-patient i {
  font-size: 2.3rem;
  color: #fff;
}

.home__wait {
  height: 94%;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 45%;
  flex: 1 0 45%;
  color: #777;
  background: #fff;
  border: 2px solid #900052;
}

.home__wait-div {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0rem 1rem;
  overflow-y: auto;
}

.home__wait-user {
  margin-top: 1rem;
  text-align: center;
  flex: 1 0 auto;
}

.home__wait-user i {
  font-size: 5rem;
}

.home__wait-user .list-patient {
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 1.5rem;
}

.home__wait-user .list-patient li {
  font-size: 1.1rem;
}

.home__wait-user .list-patient li b {
  font-weight: 600 !important;
}

.home__wait-user .list-patient li:nth-child(even) {
  margin-bottom: 0.5rem;
}

.home__wait-buttons {
  padding-bottom: 5%;
}

.btn-outline-atendiendo {
  color: #900052 !important;
  border-color: #900052 #900052 #5d0035 !important;
}

.btn-outline-atendiendo:hover {
  background-color: #900052 !important;
  border-color: #900052 !important;
  color: #fff !important;
}
</style>
